import { SearchBarSection } from "@/features/shop/components/SearchBar/SearchBarSection";
import { SearchBarAutocomplete } from "@/features/shop/components/SearchBarAutocomplete/SearchBarAutocomplete";

type SearchBarAutocompleteSectionProps = {
  title?: string
  placeholder?: string
};

export const SearchBarAutocompleteSection = ({
  title = "Que recherchez-vous ?",
  placeholder,
}: SearchBarAutocompleteSectionProps) => {
  return (
    <SearchBarSection title={title} variant="hero">
      <SearchBarAutocomplete placeholder={placeholder} />
    </SearchBarSection>
  );
};
